import Base64 from "crypto-js/enc-base64";
import Utf8 from "crypto-js/enc-utf8";
import "crypto-js/sha256";
import CryptoJS from "crypto-js/core";
import { InsAppInfo } from "@/api/http/ins/insConst";
export const sign = (jsonBody: any) => {
  const body = jsonBody || {};
  let bodyString = JSON.stringify(body);
  bodyString = bodyString || "";

  const signBody = (bodystr: string, key1: string, key2: string) => {
    const _key1 = Base64.parse(key1);
    const _key2 = Base64.parse(key2);
    const _bodystr = Utf8.parse(bodystr);

    let sha256: any = CryptoJS.algo.SHA256.create();
    sha256.update(_key1);
    sha256.update(_bodystr);
    let hash: any = sha256.finalize();

    sha256 = CryptoJS.algo.SHA256.create();
    sha256.update(_key2);
    sha256.update(hash);
    hash = sha256.finalize();
    return hash.toString();
  };

  const form: any = {};
  form.signed_body =
    signBody(bodyString, InsAppInfo.secret_key_1, InsAppInfo.secret_key_2) +
    "." +
    bodyString;
  form.ig_sig_key_version = "5";
  return form;
};
